import type { JSX } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.js';
import { useStoresList } from '@/features/stores/use-stores-list.js';

/** Code d'origine des lignes qui viennent de Pennylane (et non d'une boutique Shopify). */
export const PENNYLANE_ORIGIN = 'pennylane';

const ALL_ORIGINS_VALUE = '__all__';

export interface OriginFilterProps {
  /** `null` = « Toutes les origines ». */
  value: string | null;
  onChange: (next: string | null) => void;
  /** Ajoute Pennylane à la liste des origines (listes qui mélangent commandes et factures). */
  includePennylane?: boolean;
  className?: string | undefined;
}

/**
 * Filtre « Origine » — remplace l'ancien sélecteur de boutique global de la
 * barre supérieure : chaque liste porte désormais son propre filtre. Une
 * origine est une boutique Shopify (`fr`, `eu`…) ou, quand la liste les
 * mélange, Pennylane.
 */
export function OriginFilter({
  value,
  onChange,
  includePennylane = false,
  className,
}: OriginFilterProps): JSX.Element {
  const { data } = useStoresList();
  const stores = data?.items ?? [];

  return (
    <Select
      value={value ?? ALL_ORIGINS_VALUE}
      onValueChange={(next) => {
        onChange(next === ALL_ORIGINS_VALUE ? null : next);
      }}
    >
      <SelectTrigger className={className ?? 'w-48'} aria-label="Origine">
        <SelectValue placeholder="Toutes les origines" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_ORIGINS_VALUE}>Toutes les origines</SelectItem>
        {stores.map((item) => (
          <SelectItem key={item.code} value={item.code}>
            {item.name}
          </SelectItem>
        ))}
        {includePennylane ? <SelectItem value={PENNYLANE_ORIGIN}>Pennylane</SelectItem> : null}
      </SelectContent>
    </Select>
  );
}
